import React, { useMemo, useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import LotStatusFilter from "../components/LotStatusFilter";
import LotStatusTable from "../components/LotStatusTable";
import { useLotStatuses } from "../hooks/useLotStatuses";
import { Typography } from "@mui/material";

const LotStatusPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [query, setQuery] = useState(() => {
    const paramsObj = Object.fromEntries(searchParams.entries());
    return {
      filters: {
        code: paramsObj.code || "",
        lotStatusType: paramsObj.lotStatusType || "",
      },
      page: Number(paramsObj.page) || 1,
      pageLimit: Number(paramsObj.pageLimit) || 10,
    };
  });

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("page", query.page);
    params.set("pageLimit", query.pageLimit);
    Object.entries(query.filters).forEach(([key, value]) => {
      if (value !== "" && value !== false) params.set(key, value);
    });
    setSearchParams(params);
  }, [query, setSearchParams]);

  const { data, total, loading, error, reload } = useLotStatuses(query);

  const handleApplyFilters = (nextFilters) => {
    setQuery((prev) => ({ ...prev, filters: nextFilters, page: 1 }));
  };

  const handleClearFilters = () => {
    setQuery({
      filters: { code: "", lotStatusType: "" },
      page: 1,
      pageLimit: 10,
    });
  };

  const handlePageChange = (newPage) => {
    setQuery((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <div className="p-[30px]">
      <Typography variant="h5" sx={{ marginBottom: "30px" }}>
        Лот Статус
      </Typography>
      <LotStatusFilter
        initialFilters={query.filters}
        onApply={handleApplyFilters}
        onClear={handleClearFilters}
      />

      <LotStatusTable
        data={data}
        loading={loading}
        error={error}
        total={total}
        page={query.page}
        pageLimit={query.pageLimit}
        onPageChange={handlePageChange}
        onChanged={reload}
      />
    </div>
  );
};

export default LotStatusPage;
